<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn
                v-if="$route.name != `ProfilePage`"
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true
                    ? 'Staff KYC Documents'
                    : 'Deleted Franchisees'
                "
              ></h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    hide-details="auto"
                    v-model="filter.search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @click:clear="(filter.is_active = null), (page = 1)"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    v-model="filter.status"
                    :items="approvalStatus"
                    label="Approval Status"
                    @click:clear="(filter.status = null), (page = 1)"
                    @input="(page = 1), getData()"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Bank details of the staff member (sent from the app with KYC) -->
      <v-row v-if="owner">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title class="subtitle-1 font-weight-bold pb-2">
              <v-icon left color="primary">mdi-bank</v-icon>
              Bank Details
              <span class="body-2 grey--text text--darken-1 ml-2">
                {{ ownerName }}<template v-if="owner.employee_code"> &middot; {{ owner.employee_code }}</template>
              </span>
            </v-card-title>
            <v-card-text>
              <v-row v-if="owner.account_number || owner.ifsc_code || owner.bank_name">
                <v-col md="4" cols="12">
                  <div class="caption grey--text text--darken-1">Account Number</div>
                  <div class="subtitle-1 font-weight-medium">{{ owner.account_number || "—" }}</div>
                </v-col>
                <v-col md="4" cols="12">
                  <div class="caption grey--text text--darken-1">IFSC Code</div>
                  <div class="subtitle-1 font-weight-medium">{{ owner.ifsc_code || "—" }}</div>
                </v-col>
                <v-col md="4" cols="12">
                  <div class="caption grey--text text--darken-1">Bank Name</div>
                  <div class="subtitle-1 font-weight-medium">{{ owner.bank_name || "—" }}</div>
                </v-col>
              </v-row>
              <div v-else class="body-2 grey--text text--darken-1">
                Not submitted yet. Staff add bank details from the app while uploading KYC.
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Approval Status</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Number</th>
                      <th class="text-left">Preview</th>
                      <th class="text-left">Rejection Reason</th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="user_kyc_documents.length != 0">
                    <tr
                      v-for="(user_kyc_document, i) in user_kyc_documents"
                      :key="`user_kyc_document${i}`"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip
                          bottom
                          v-if="user_kyc_document.is_active == 1"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Franchisee is Active</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="user_kyc_document.is_active == 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Franchisee is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-tooltip bottom v-if="user_kyc_document.status == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Document is Approved</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="user_kyc_document.status == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="yellow"
                              text-color="black"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Waiting for Approval</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="user_kyc_document.status == 2">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Document is Rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ user_kyc_document.document_type.code || "" }}
                      </td>
                      <td>{{ user_kyc_document.document_number || "" }}</td>
                      <td>
                        <v-tooltip top v-if="user_kyc_document.document_path">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              color="primary"
                              x-small
                              target="_blank"
                              :href="`${
                                mediaUrl + user_kyc_document.document_path
                              }`"
                              >View</v-btn
                            >
                          </template>
                          <span
                            >Preview <br />{{
                              user_kyc_document.updated_at | YmdHM
                            }}</span
                          >
                        </v-tooltip>
                      </td>
                      <td>{{ user_kyc_document.remark || "" }}</td>
                      <td style="min-width: 160px">
                        {{ formatDate(user_kyc_document.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 215px">
                        <v-tooltip
                          bottom
                          v-if="
                            (visible_to(['FRANCHISEE ADMIN']) &&
                              !user_kyc_document.document_path) ||
                            visible_to(['ADMIN'])
                          "
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                              fab
                              x-small
                              color="primary"
                              :to="`/user-kyc-documents/${encryptIt(
                                user_kyc_document.id
                              )}`"
                            >
                              <v-icon dark> mdi-pencil </v-icon>
                            </v-btn>
                          </template>
                          <span>{{
                            positionName == "FRANCHISEE ADMIN"
                              ? "Submit Document"
                              : "Review Kyc Document"
                          }}</span>
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="
                            visible_to(['FRANCHISEE ADMIN']) &&
                            user_kyc_document.document_path &&
                            user_kyc_document.status == 2
                          "
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                              fab
                              x-small
                              color="primary"
                              :to="`/user-kyc-documents/re-submit/${encryptIt(
                                user_kyc_document.id
                              )}`"
                            >
                              <v-icon dark> mdi-pencil </v-icon>
                            </v-btn>
                          </template>
                          <span>{{
                            positionName == "FRANCHISEE ADMIN"
                              ? "Re-Submit New Document"
                              : "Review Kyc Document"
                          }}</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="1000" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_user_kyc_document" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Franchisee deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_user_kyc_document = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_user_kyc_document" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Franchisee restored successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_restored_user_kyc_document = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "user_kyc_documentsPage",
  data() {
    return {
      filter: {
        active: "",
      },
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      is_deleted_user_kyc_document: false,
      restore_user_kyc_document: false,
      is_restored_user_kyc_document: false,
      user_kyc_documents: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      approvalStatus: [
        {
          id: 0,
          text: "PENDING",
          value: "0",
        },
        { id: "APPROVED", text: "APPROVED", value: "1" },
        { id: "REJECTED", text: "REJECTED", value: "2" },
      ],
      isLoading: false,
    };
  },
  computed: {
    // Only when the list is one staff member's documents (opened from Franchise Staff)
    owner() {
      if (!this.filter.user_id) return null;
      const doc = this.user_kyc_documents.find((d) => d.user);
      return doc ? doc.user : null;
    },
    ownerName() {
      if (!this.owner) return "";
      const full = [this.owner.first_name, this.owner.last_name].filter(Boolean).join(" ");
      return full || this.owner.user_name || "";
    },
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.filter.user_id = this.$route.query.user_id
      ? parseInt(this.decryptIt(this.$route.query.user_id))
      : "";
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    async getData() {
      console.log("Get Data");
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      this.filter.is_kyc_valid = this.filter.is_kyc_valid
        ? this.filter.is_kyc_valid
        : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&is_kyc_valid=" +
        this.filter.is_kyc_valid +
        "&user_id=" +
        this.filter.user_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`user_kyc_documents?${query}`)
        .then((response) => {
          this.user_kyc_documents = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_user = true;
      await axios
        .post(`/users/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_user = false;
          this.is_deleted_user = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
          // window.location.href = "/auth/login";
        });
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    async Restore_this(id) {
      this.restore_user = true;
      await axios
        .post(`/users/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_user = false;
          this.is_restored_user = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
          // window.location.href = "/auth/login";
        });
    },
  },
};
</script>
